<template>
  <modal
    name="iPhoneAgree"
    role="dialog"
    aria-labelledby="dialog-title"
    aria-describedby="dialog-content"
    class="m-full"
    :width="700"
    :height="740"
    :maxHeight="740"
    :scrollable="true"
    @before-close="beforeClose"
  >
    <div class="dialog__inner">
      <div class="popup-header">
        <h1 id="dialog-title" tabindex="0">iPhone 이용고객 동의서</h1>
        <button
          type="button"
          class="btn_popup_close"
          data-dismiss="modal"
          title="팝업닫기"
          @click="closeDialog"
        >
          <span>팝업 닫기</span>
        </button>
      </div>
      <div id="dialog-content" class="dialog__content">
        <div class="section">
          <div class="section-header blind">
            <h3>iPhone 이용고객 동의 내용</h3>
          </div>
          <div class="section-body">
            <ul class="notice-text-list" tabindex="0">
              <li class="notice-text">
                iPhone 이용 고객 동의 사항을 잘 숙지해주시고, 가입 동의 서명을
                해주세요. 미동의 시 개통이 불가합니다.
              </li>
            </ul>

            <dl class="field-group vertical">
              <dt class="field-label">
                <h4 role="heading" tabindex="0">iPhone의 AS 관련 사항</h4>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub text-detail scrollable">
                  <p role="region" tabindex="0" class="td-term">
                    ㅇ 단말 기능상 문제 또는 표면상의 결함 시 공정위와 Apple이
                    합의한 소비자 분쟁 해결 기준에 따라 Apple 공식AS센터에서
                    다음과 같이 AS를 받으실 수 있습니다. 표면상의 결함 시 AS
                    가능 여부는 전적으로 Apple 공식AS센터의 판단 기준에
                    의거합니다.<br /><br />
                    - 개통일 포함 10일 이내에는 개통취소 혹은 신제품 교환 (박스
                    및 구성품 모두 포함)이 가능합니다. <br />
                    단, 개통 취소를 위해서는 Apple 공식AS센터 방문 후 개통
                    대리점에 내방하셔야 합니다. <br />
                    - 개통일 포함 31일 이내에는 Apple 공식AS센터에서 신제품
                    교환(박스 및 구성품 모두 포함)이 가능합니다<br />
                    단, 구매하신 아이폰이 Remanufactured 제품인 경우에는 ,
                    적용되지 않고 1년 이내 무상 수리만 가능합니다 (신제품 교환
                    불가)<br /><br />
                    ㅇ 개통일 포함 31일 이후에는 Apple의 공식 AS센터를 방문하여
                    Apple의 품질보증 기준에 따라 무상수리 (서비스제품
                    교환/부분수리)가 가능하며,고객 과실을 비롯하여 Apple의
                    품질보증 기준 이외의 경우는 1년 이내라도 실비의 수리비가
                    청구될 수 있습니다.<br /><br />
                    ㅇ 상세한 Apple의 AS 기준 등 관련 사항은 웹사이트
                    <a
                      href="https://www.apple.com/"
                      target="_blank"
                      title="새 창 열림"
                      >www.apple.com</a
                    >에서 확인 가능합니다.
                  </p>
                </div>
              </dd>
            </dl>

            <dl class="field-group vertical">
              <dt class="field-label">
                <h4 role="heading" tabindex="0">iPhone의 서비스 관련 사항</h4>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub text-detail scrollable">
                  <p role="region" tabindex="0" class="td-term">
                    ㅇ iPhone으로 무선인터넷 이용 시, Wi-Fi지역에서 벗어나면
                    자동으로 유료인 LG U+ LTE에 접속되며 무선 인터넷 요금이
                    부과됩니다. <br />
                    Wi-Fi 지역에서 벗어나더라도 별도의 안내 문구가 표시되지 않기
                    때문에 무선 인터넷 이용 시에는 아이폰 액정 화면에 있는
                    안테나 표시를 확인하시기 바랍니다.<br /><br />
                    ㅇ iPhone에서 140byte이상 장문 SMS발송 시 별도 알림 없이,
                    MMS로 자동 전환되어 전송됩니다.<br /><br />
                    ㅇ iPhone에 사용되는 USIM은 나노USIM입니다. 고객께서는
                    구입하신 제품에 적합한 정품 유심을 사용하셔야 합니다.<br /><br />
                    ㅇ 부적합한 USIM을 사용하여 발생하는 문제에 대해서는
                    정상적인 AS가 어려울 수 있으며 LG U+는 이에 대해 어떠한
                    책임도 지지 않습니다.<br /><br />
                    ㅇ 하드웨어 및 소프트웨어 (OS 포함) 에 대한 임의 변경 시
                    (해킹/크래킹/제일브레이크 등) LG U+는 서비스의 품질을 보장할
                    수 없으며, 바이러스 감염 등을 통해 예상치 못한 피해가 발생할
                    수 있습니다. LG U+는 이에 대해 어떠한 책임도 지지
                    않습니다.<br /><br />
                    ㅇ 기존 스마트폰에서 제공하던 서비스 (U+ share, U+ Navi LTE,
                    IoT@home, U+ 헬스, 연락의 신, 만화1번지 등) 중 일부는 이용이
                    불가합니다.
                  </p>
                </div>
              </dd>
            </dl>

            <dl class="field-group vertical">
              <dt class="field-label">
                <h4 role="heading" tabindex="0">
                  기타 iPhone 사용시 유의사항 안내
                </h4>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub text-detail scrollable">
                  <p role="region" tabindex="0" class="td-term">
                    ㅇ 인터넷 뱅킹 : 각 은행의 지원 여부에 따라 다릅니다.
                    (하나/국민/기업/신한 등 가능하나 그 외는 은행에 문의해야
                    합니다.)<br /><br />
                    ㅇ 아이메세지 : 애플 기기간 무료 문자메세지로 타기종에서는
                    제공되지 않습니다.<br /><br />
                    ㅇ 01X번호로 개통이 불가합니다.<br /><br />
                    ㅇ 당사에서 제공되고 있는 서비스가 불가능할 수 있습니다. ex)
                    DMB, NFC (T머니), 듀얼번호, 벨소리 등<br /><br />
                    ㅇ 무한대 요금제의 무료 100분 영상통화 제공불가 등 (아이폰
                    자체 기능 제공불가로 별도 혜택 제공 불가)<br /><br />
                    ㅇ 그 외 서비스 등 <br />* 미제공 서비스 등에 대해서는
                    점진적 적용 예정으로 서비스 제공 가능 시 별도 고지
                    예정입니다.
                  </p>
                </div>
              </dd>
            </dl>
            <p class="data-text">
              본인은 iPhone을 이용함에 있어 상기 관련 내용 및 AS정책에 대해
              충분히 안내 받고 가입함에 동의합니다.
            </p>
          </div>
        </div>
      </div>
      <div class="dialog__footer">
        <button @click="confirmDialog" type="button" class="primary-button">
          확인
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'IphoneAgreePopup',

  created() {
  },
  methods: {
    /** 
     * Function    : closeDialog
     * Description : Dialog 닫기
     **/
    closeDialog() {
      this.$modal.hide('iPhoneAgree')
    },

    beforeClose() {
      if(!this.$store.state.isConfirm) {
        this.$emit('close', {
          id: 'fail',
          ok: 'N'
        })
      }
      this.$store.state.isConfirm = false
    },

    /** 
     * Function    : confirmDialog
     * Description : 확인 클릭 시 이벤트 함수
     **/
    confirmDialog() {
      this.$store.state.isConfirm = true
      this.$emit('close', {
        id: 'ok',
        ok: 'Y'
      })
      this.$modal.hide('iPhoneAgree')
    },
  }
}
</script>

<style scoped></style>
